export default __webpack_public_path__ + "static/media/logo-instituto.4ccfe491.svg";